(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d24h-corsi-patentini"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-d24h-training]').forEach(function(root){
  var buttons = Array.from(root.querySelectorAll('[data-d24h-filter]'));
  var cards = Array.from(root.querySelectorAll('[data-d24h-card]'));
  var counter = root.querySelector('[data-d24h-count]');
  var empty = root.querySelector('[data-d24h-empty]');
  if (!buttons.length || !cards.length) return;
  function applyFilter(value){
    var visible = 0;
    cards.forEach(function(card){
      var show = value === 'all' || card.dataset.category === value;
      card.hidden = !show;
      if (show) visible += 1;
    });
    buttons.forEach(function(button){
      var active = button.dataset.d24hFilter === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    if (counter) counter.textContent = visible + (visible === 1 ? ' percorso' : ' percorsi');
    if (empty) empty.hidden = visible !== 0;
  }
  buttons.forEach(function(button){
    button.addEventListener('click', function(){ applyFilter(button.dataset.d24hFilter); });
  });
  applyFilter('all');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d24h-riprese-drone"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-d24h-film]').forEach((section) => {
    const video = section.querySelector('[data-dv-hero-video]');
    const button = section.querySelector('[data-dv-toggle]');
    const label = section.querySelector('[data-dv-toggle-label]');
    const icon = section.querySelector('[data-dv-toggle-icon]');

    if (!video || !button || !label || !icon) return;

    const syncState = () => {
      const isPaused = video.paused;
      button.setAttribute('aria-pressed', String(isPaused));
      label.textContent = isPaused ? button.dataset.playLabel : button.dataset.pauseLabel;
      icon.textContent = isPaused ? '▶' : 'Ⅱ';
    };

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(syncState);
      } else {
        video.pause();
      }
      syncState();
    });

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
    }

    syncState();
  });

  } catch(e) { console.error(e); }
})();
})();
